// FRS 4.2.1 Phase 5 - map rating code (จาก BE) -> ป้ายระดับประสิทธิภาพ กฟผ.
// code มาจาก VRFOutdoor.seer_rating: below / 5 / 5_1..5_5 / out_of_range / null

const STAR = '★'; // ★

export const RATING_META = {
  below: { level: 'below', stars: 0, color: '#c0392b', bg: '#fdecea' },
  '5': { level: '5', stars: 0, color: '#1e7e34', bg: '#e6f4ea' },
  '5_1': { level: '5', stars: 1, color: '#1e7e34', bg: '#e6f4ea' },
  '5_2': { level: '5', stars: 2, color: '#1e7e34', bg: '#e6f4ea' },
  '5_3': { level: '5', stars: 3, color: '#1e7e34', bg: '#e6f4ea' },
  '5_4': { level: '5', stars: 4, color: '#1e7e34', bg: '#e6f4ea' },
  '5_5': { level: '5', stars: 5, color: '#1e7e34', bg: '#e6f4ea' },
  out_of_range: { level: 'out_of_range', stars: 0, color: '#8a6d3b', bg: '#fcf3d9' },
};

// คืน label ที่แปลแล้ว (ต้องส่ง t ของ i18n เข้ามา)
export const ratingLabel = (code, t) => {
  if (!code) return '-';
  if (code === 'below') return t('below standard');
  if (code === 'out_of_range') return t('out of criteria range');
  const meta = RATING_META[code];
  if (!meta) return code;
  const stars = meta.stars > 0 ? ' ' + STAR.repeat(meta.stars) : '';
  return t('energy label no.5') + stars;
};

export const ratingStyle = code => {
  const meta = (code && RATING_META[code]) || RATING_META.out_of_range;
  return {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: 12,
    fontWeight: 600,
    color: meta.color,
    backgroundColor: meta.bg,
    fontSize: 13,
  };
};



// WEBPACK FOOTER //
// ./src/components/vrf/vrfSeerRating.js